import Loader from 'components/_UI/Loader'
import Text from 'components/_UI/Text'
import React, { useEffect } from 'react'
import { useCollapse } from 'context/general/Collapse'
import { Column } from 'styled/alignment/Column'
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row'
import Icon from 'components/_UI/Icon'
import colors from 'theme/colors'
import { FullyCentered } from 'styled/alignment/Center'
import establishmentApi from 'api/requests/establishments'
import { useSearchParams } from 'react-router-dom'
import { useBackButtonCollapse } from 'context/general/BackButtonCollapse'
import breakpoints from 'theme/breakpoints'
import ResumeCard from '../card/CardResume'
import CardProfile from 'modules/dashboard/profile/parts/CardProfile'

const FiltersResult = React.forwardRef(({ data, error, routeParams, onEventClick }, ref) => {

    const [searchParams, setSearchParams] = useSearchParams();

    const { collapse, setCollapse } = useCollapse();
    const { backButtonCollapse, setBackButtonCollapse } = useBackButtonCollapse();

    function renderResult() {
        if (data.length) {
            return (
                <Column fullyCentralized>
                    <Text name='highlight'>
                        {
                            data.length > 1
                                ? `Foram encontrados ${data.length} estabelecimentos na sua busca`
                                : `Foi encontrado ${data.length} estabelecimento na sua busca`
                        }
                    </Text>
                    <ResponseContent>
                        {
                            data.map(el => (
                                <ResumeCard
                                    data={el}
                                    key={el.id}
                                    onCardClick={(e) => renderEstablishmentDetail(e)}
                                    smallOnDesktop={true}
                                />
                            ))
                        }
                    </ResponseContent>
                </Column>
            )
        }

        if (error) {
            return (
                <ErrorContainer>
                    <Text
                        name='subtitle'
                        color={colors.night}
                    >
                        Ops... Ocorreu um erro inesperado, tente novamente.
                    </Text>
                </ErrorContainer>
            )
        }

        return (
            <ErrorContainer>
                <Column
                    width='70px'
                    height='70px'
                    marginBottom='24px'
                >
                    <Icon
                        color={colors.night}
                        name='marker-not-found'
                    />
                </Column>
                <Text
                    name='subtitle'
                    color={colors.night}
                >
                    Infelizmente não foram encontrados resultados para a sua busca.
                </Text>
            </ErrorContainer>
        )
    }

    async function renderEstablishmentDetail(establishment) {
        setBackButtonCollapse({
            ...backButtonCollapse,
            from: 'filter-result',
            data: routeParams
        })

        setSearchParams({ estabelecimento: establishment.slug })

        setCollapse({
            ...collapse,
            withContent: true,
            height: 'max',
            arrowPosition: false,
            componentToRender: () => establishment && (
                <FullyCentered height='100%'>
                    <Loader />
                </FullyCentered>
            )
        })

        try {
            const { data } = await establishmentApi.getBySlug(establishment.slug)
            setCollapse({
                ...collapse,
                withContent: true,
                height: 'max',
                arrowPosition: false,
                componentToRender: () => data && <CardProfile onEventClick={onEventClick} data={data.data} fullWidth withBackButton />
            })
        } catch (error) {
            setCollapse({
                ...collapse,
                withContent: true,
                height: 'max',
                arrowPosition: false,
                componentToRender: () => establishment && (
                    <FullyCentered height='100%'>
                        <Text>Ocorreu um erro inesperado.</Text>
                    </FullyCentered>
                )
            })
        }
    }

    return (
        <ResultContainer ref={ref}>
            {renderResult()}
        </ResultContainer>

    )
})

export default FiltersResult;

const ResultContainer = styled(Column)`
    padding: 25px 0 50px 0;
`;


const ResponseContent = styled(Row)`
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-around;

    & > div {
            width: 45%;
        }
    
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
        & > div {
            width: 31%;
        }
    }
`;

const ErrorContainer = styled(Column)`
    width: 100%;
    height: 150px;
    text-align: center;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
`